{
  "nl": {
    "task": {
      "actions": {
        "create": "Taak",
        "create_and_send": "Aanmaken en versturen",
        "save_as_draft": "Opslaan als concept",
        "update": "Taak bewerken"
      },
      "attributes": {
        "assignments_count": "Toewijzingen",
        "category": "Manier van afronden",
        "created_at": "Aangemaakt",
        "description": "Omschrijving",
        "title": "Titel",
        "units": "Eenheden"
      },
      "categories": {
        "confirmation": "Bevestiging",
        "upload": "Document uploaden"
      },
      "categories_info": {
        "confirmation": "De toegewezen persoon vinkt de taak af zodra ze klaar is.",
        "upload": "De toegewezen persoon moet een document uploaden om de taak af te ronden."
      },
      "labels": {
        "no_tasks": "Nog geen taken voor dit project.",
        "required": "Dit veld is verplicht",
        "set_all_assignees": "De toegewezene instellen | Alle {count} toegewezenen instellen",
        "still_to_do": "nog {count} te doen",
        "units_count": "{count} eenheid | {count} eenheden",
        "units_required": "Selecteer minstens één eenheid"
      },
      "toasts": {
        "create": "Taak aangemaakt",
        "delete": "Taak verwijderd",
        "update": "Taak bijgewerkt"
      }
    }
  }
}
